export default __webpack_public_path__ + "static/media/MOTIVO_07.3489acbd.jpg";